export const enum YourAppsListSubItem {
  FullscreenApp = 'Fullscreen app',
  Settings = 'Settings',
}
